import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../../Common";
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";
import RemarkDialog from "../../RemarkDialog";
import Tran_data_unlock_request from "../../Tran_data_unlock_request";

const Tran_modification_payment = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem("sessionId");
    // const userSrno = sessionStorage.getItem("userSrno");
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [tranLocation, setTranLocation] = useState(null);
    const [tranType, setTranType] = useState("PP");
    const [tranSrno, setTranSrno] = useState("");
    const [locationCode, setLocationCode] = useState(0);
    const [paymentData, setPaymentData] = useState([]);
    const [editViewBtn, setEditViewBtn] = useState(false);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [compareData, setCompareData] = useState([]);
    const [showRemarkModal, setShowRemarkModal] = useState(false);
    const [saveObj, setSaveObj] = useState({});

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });

    const [unlockRequestType, setUnlockRequestType] = useState("");

    useEffect(() => {
        Common.getActiveBranch().then(response => {
            setTranLocation(response);
            response != null && handleLocationChange(response);
        });

        Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_PAYMENT_MODIFICATION'], function (result) {
            let resp = JSON.parse(result);
            if (resp.query === "1") {
                setUserRight(resp);
            } else {
                navigate('/'); // no query right
            }
        });

        // const sessionValues = sessionStorage.getItem('values');
        // if (sessionValues) {
        //     const sessionData = JSON.parse(sessionValues);
        //     if (sessionData.md_type == "PURCHASE") {
        //         Common.callApi(Common.apiIndividualProfile, [sid, 'getIndividualData', sessionData.code], (result) => {
        //             let resp = JSON.parse(result);
        //         });
        //         sessionStorage.removeItem('values');
        //     } else {
        //         setScrMode('');
        //     }
        // }
    }, []);

    const handleLocationChange = (value) => {
        setTranLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
    }

    const handleList = () => {
        $(".loader").show();
        if (tranSrno == "") {
            $(".loader").hide();
            setMsgText("Please fill Srno.");
            setMsgBox(true);
        } else {
            const obj = {
                locationCode: locationCode,
                tranType: tranType,
                tranSrno: tranSrno,
            }
            Common.callApi(Common.apiModiPayment, [sid, "getPaymentList", JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setPaymentData(resp.paymentDetails);
                setEditViewBtn(false);
                setUnlockRequestType("");
            });
        }
    }

    const handleBankValue = (value, uniquekey) => {
        const itemToUpdate = paymentData.find(item => item.uniquekey === uniquekey);
        if (!itemToUpdate) return;

        setPaymentData(prevData =>
            prevData.map(row =>
                row.uniquekey === uniquekey
                    ? { ...row, tp_ledger: value.label, tp_group: value.id.split('^')[1], tp_account: value.id.split('^')[2] }
                    : row
            )
        );

    }

    const handleChequeValue = (value, uniquekey) => {
        setPaymentData(prevData =>
            prevData.map(row =>
                row.uniquekey === uniquekey
                    ? { ...row, tp_cheque: value }
                    : row
            )
        );
    }

    const handlePaymentType = (value, item) => {
        const obj = {
            srno: item.tp_srno,
            type: item.tp_type,
            location: item.tp_location,
            lineNo: item.tp_line_no,
            paymentType: value
        };
        Common.callApi(Common.apiModiPayment, [sid, "getPaymentAccount", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            setPaymentData(prevData =>
                prevData.map(row =>
                    row.uniquekey === item.uniquekey
                        ? {
                            ...row, tp_payment_type: value,
                            tp_group: resp.group,
                            tp_account: resp.account,
                            mvli_ledger_name: resp.ledger_name,
                            tp_ledger: resp.group + ' ' + resp.account + resp.ledger_name,
                            tp_cheque: value === "RC" || value === "PB" ? "" : resp.cheque
                        }
                        : row
                )
            );
        });
    }

    // const handleType = (value, uniquekey) => {
    //     setPaymentData(prevData =>
    //         prevData.map(row =>
    //             row.uniquekey === uniquekey
    //                 ? { ...row, tp_type: value }
    //                 : row
    //         )
    //     );
    // }

    // const handlePaymentType = (value, uniquekey) => {
    //     setPaymentData(prevData =>
    //         prevData.map(row =>
    //             row.uniquekey === uniquekey
    //                 ? { ...row, tp_payment_type: value }
    //                 : row
    //         )
    //     );
    // }
    const fillViewCompareObject = (item, paymentData) => {
        const matchedItem = paymentData.find(row => row.uniquekey === item.uniquekey);

        if (matchedItem) {
            const obj = {
                group: matchedItem.tp_group,
                account: matchedItem.tp_account,
                cheque: matchedItem.tp_cheque,
            };
            setCompareData([obj]);
        } else {
            console.log("Data Nahi mila");
        }
    };

    const handleEditRequest = (item) => {
        var pageright = "";
        if (item.tp_type === "PP") pageright = "TRAN_PP";
        else if (item.tp_type === "PB") pageright = "TRAN_PB";
        else if (item.tp_type === "SP") pageright = "TRAN_SP";
        else if (item.tp_type === "SB") pageright = "TRAN_SB";

        const obj = {
            srno: item.tp_srno,
            type: item.tp_type,
            pageright: pageright,
            location: item.tp_location
        }
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (resp.msg == "unlock") {
                setEditViewBtn(true);
                setPaymentData(prevData =>
                    prevData.map(row =>
                        row.uniquekey === item.uniquekey
                            ? { ...row, payment_disable: "0" }
                            : row
                    )
                );
                setPaymentData(prevData => {
                    fillViewCompareObject(item, prevData);
                    return prevData;
                });
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: item.tp_type, trannumber: item.tp_srno, location: item.tp_location, tranDate: item.hdr_date });
            }
        });
    }

    const confirmPayment = (remark) => {
        $(".loader").show();
        var msg = [], i = 0;
        if ((saveObj.tp_payment_type === "BN" && saveObj.tp_cheque === "") || saveObj.tp_group === "" || saveObj.tp_account === "") {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (saveObj.tp_group === "" ? "Bank" : '');
            msg[i++] = (saveObj.tp_account === "" ? "Bank" : '');
            msg[i++] = ((saveObj.tp_payment_type === "BN" && saveObj.tp_cheque === "") ? "Cheque" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                // type: saveObj.tp_type,
                paymentType: saveObj.tp_payment_type,
                group: saveObj.tp_group,
                account: saveObj.tp_account,
                cheque: saveObj.tp_cheque,
                prev_cheque_no: saveObj.tp_cheque_prev,
                uniquekey: saveObj.uniquekey,
                srno: saveObj.tp_srno,
                type: saveObj.tp_type,
                location: saveObj.tp_location,
                lineNo: saveObj.tp_line_no,
                amount: saveObj.tp_amount,

                locationCode: locationCode,
                tranType: tranType,
                tranSrno: tranSrno,
                payRemark: remark,
            }
            const infoObject = Common.compareArrays(compareData, [obj]);
            setTranAuditTrail(Common.addInfoToAuditTrail(tranAuditTrail, infoObject, saveObj.tp_type, locationCode));
            Common.callApi(Common.apiModiPayment, [sid, "confirmPayment", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                // console.log(resp);
                setShowRemarkModal(false);
                setEditViewBtn(false);
                setTranAuditTrail([]);
                if (resp.msg !== "") {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                    expireUnlock(saveObj);
                } else {
                    setPaymentData(resp.paymentDetails);
                }
            });
        }
    }

    const expireUnlock = (saveObj) => {
        var pageright = "";
        if (saveObj.tp_type === "PP") pageright = "TRAN_PP";
        else if (saveObj.tp_type === "PB") pageright = "TRAN_PB";
        else if (saveObj.tp_type === "SP") pageright = "TRAN_SP";
        else if (saveObj.tp_type === "SB") pageright = "TRAN_SB";
        if (unlockRequestType !== "SELF") {
            const obj = {
                srno: saveObj.tp_srno,
                type: saveObj.tp_type,
                status: 'E',
                currentDate: saveObj.hdr_date,
                pageright: pageright
            }
            Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                console.log(result);
            });
        }
    }

    const showRemarkModel = (item) => {
        setShowRemarkModal(true);
        setSaveObj(item)
    }

    const remarkModelHandler = (obj) => {
        confirmPayment(obj?.remark);
    }



    // const confirmDeletion = (item) => {
    //     $(".loader").show();
    //     const obj = {
    //         srno: item.tp_srno,
    //         type: item.tp_type,
    //         location: item.tp_location,
    //         lineNo: item.tp_line_no,

    //         locationCode: locationCode,
    //         tranType: tranType,
    //         tranSrno: tranSrno,
    //     }
    //     Common.callApi(Common.apiModiPayment, [sid, "confirmDeletion", JSON.stringify(obj)], (result) => {
    //         $(".loader").hide();
    //         let resp = JSON.parse(result);
    //         console.log(resp);
    //         // setPaymentData(resp);
    //     });
    // }



    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Transaction Payment Modification</h3>
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={tranLocation}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={Picklist.fetchLocationAllowedPicklist}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleLocationChange}
                            // isDisabled={branchDisable === "true"}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                    <Col className="col-md-3 col-6">
                        <Form.Label>Transaction</Form.Label>
                        <Form.Select
                            value={tranType}
                            onChange={(e) => setTranType(e.target.value)}>
                            <option value="PP">PP</option>
                            <option value="PB">PB</option>
                            <option value="SP">SP</option>
                            <option value="SB">SB</option>
                        </Form.Select>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>SrNo<span className="colorThemeRed">*</span></Form.Label>
                            <Form.Control type='text' maxLength={10} value={tranSrno} onChange={e => Common.validateNumValue(e.target.value, setTranSrno)} />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Button style={{ marginTop: '32px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={handleList}> List</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Table responsive bordered striped>
                        <thead>
                            <tr>
                                <th>Source</th>
                                <th>Type</th>
                                <th>Payment Type</th>
                                <th>Bank</th>
                                <th>Cheque No.</th>
                                <th>Amount</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paymentData?.map((item, index) => (
                                <React.Fragment key={index}>
                                    {/* Product Row */}
                                    <tr>
                                        <td>{item.hdr_tran_source}</td>
                                        <td>{item.tp_type}</td>
                                        <td>{item.tp_payment_type == "BN" ? "Bank" : item.tp_payment_type == "RC" ? "Receivables" : item.tp_payment_type == "PB" ? "Payables" : ""}</td>
                                        <td>{item.tp_group + ' ' + item.tp_account + ' ' + item.mvli_ledger_name}</td>
                                        <td>{item.tp_cheque}</td>
                                        <td>{item.tp_amount}</td>
                                        <td>
                                            {(userRight.edit === "1" && !editViewBtn && item.hdr_tran_source !== 'EREMIT') ?
                                                <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => handleEditRequest(item)}>Edit</Button>
                                                // <span onClick={() => handleEditRequest(item)} className='handCursor colorThemeBlue'>
                                                //     <FontAwesomeIcon icon={faEdit} />
                                                // </span>
                                                : null}
                                        </td>
                                    </tr>

                                    {/* Payment Row with Editable Fields */}
                                    {
                                        editViewBtn ?
                                            <>

                                                <tr>
                                                    <td colSpan="6">
                                                        <table style={{ width: '100%' }}>
                                                            <thead>
                                                                <tr>
                                                                    {/* <th>Type</th>
                                                        <th>Payment Type</th> */}
                                                                    <th>Type</th>
                                                                    <th>Bank</th>
                                                                    <th>Cheque No.</th>
                                                                    <th>&nbsp;</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    {
                                                                        /* 
                                                                            <td>
                                                                            {(userRight.edit === "1" && !editViewBtn) ?
                                                                            <span onClick={() => confirmDeletion(item)} className='colorThemeBlue pointer'>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </span> : null}
                                                                            </td> 
                                                                        */
                                                                    }
                                                                    {
                                                                        /* <td className='col-md-3 col-6'>
                                                                        <Form.Select
                                                                            value={item.tp_type}
                                                                            onChange={e => handleType(e.target.value, item.uniquekey)}
                                                                            // disabled={item.payment_disable === "1"}
                                                                            disabled
                                                                        >
                                                                            <option value="PP">PP</option>
                                                                            <option value="PB">PB</option>
                                                                            <option value="SP">SP</option>
                                                                            <option value="SB">SB</option>
                                                                        </Form.Select>
                                                                        </td>
                                                                        <td className='col-md-3 col-6'>
                                                                            <Form.Control
                                                                                type="text"
                                                                                maxLength={5}
                                                                                value={item.tp_payment_type}
                                                                                onChange={e => handlePaymentType(e.target.value, item.uniquekey)}
                                                                                // disabled={item.payment_disable === "1"}
                                                                                disabled
                                                                            />
                                                                        </td> */
                                                                    }
                                                                    <td className='col-md-4'>
                                                                        <Form.Select value={item.tp_payment_type} onChange={e => handlePaymentType(e.target.value, item)}>
                                                                            <option value="BN">Bank</option>
                                                                            {(tranType === 'PP') || (tranType === 'PB') ?
                                                                                <option value="PB">Payable</option>
                                                                                : (tranType === 'SP') || (tranType === 'SB') ?
                                                                                    <option value="RC">Receivable</option>
                                                                                    : null
                                                                            }
                                                                        </Form.Select>
                                                                    </td>
                                                                    <td className='col-md-4' >
                                                                        <AsyncSelect
                                                                            cacheOptions={false}
                                                                            defaultOptions={false}
                                                                            value={{ label: item.tp_ledger, id: item.tp_group + '^' + item.tp_account + '^' + item.mvli_ledger_name }}
                                                                            getOptionLabel={e => e.label}
                                                                            getOptionValue={e => e.id}
                                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'BANK', locationCode)}
                                                                            onInputChange={Picklist.handleInputChange}
                                                                            onChange={(value) => handleBankValue(value, item.uniquekey)}
                                                                            isDisabled={item.tp_payment_type === "RC" || item.tp_payment_type === "PB"}
                                                                            menuPortalTarget={document.body}
                                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                        />
                                                                    </td>
                                                                    <td className='col-md-4 '>
                                                                        {
                                                                            item.tp_payment_type === "RC" || item.tp_payment_type === "PB" ? null
                                                                                :

                                                                                <Form.Control
                                                                                    type="text"
                                                                                    maxLength={50}
                                                                                    value={item.tp_cheque}
                                                                                    onChange={e => handleChequeValue(e.target.value, item.uniquekey)}
                                                                                // disabled={item.payment_disable === "1"}
                                                                                />

                                                                        }
                                                                    </td>

                                                                    <td className='col-md-4 '>
                                                                        {
                                                                            (userRight.edit === "1" && editViewBtn) ?
                                                                                <Button style={{ marginRight: '10px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={() => showRemarkModel(item)}>Save</Button>
                                                                                // <Badge bg='success' onClick={() => confirmPayment(item)} className='pointer'>
                                                                                //     Save
                                                                                // </Badge> 
                                                                                : null
                                                                        } &nbsp; &nbsp;
                                                                        {/* {(userRight.edit === "1" && editViewBtn) ?
                                                                <span onClick={() => handleEditRequest(item)} className='handCursor colorThemeBlue'>
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </span> : null} */}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </> : null
                                    }
                                </React.Fragment>
                            ))}
                        </tbody>
                    </Table>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            < RemarkDialog show={showRemarkModal} hide={() => setShowRemarkModal(false)} action={remarkModelHandler} />
            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
        </>
    )
}

export default Tran_modification_payment;
